/**
 * Game gravity
 */
export const GRAVITY = 0.4;



// WEBPACK FOOTER //
// ./app/scripts/game/utils/constants.ts